import { Dispatch } from "redux";
import { getUserProfileApi } from "../../apis/profile";
import { handleApiError } from "../../helpers";
import { Borrower } from '../../interfaces';
import { UserProfile } from "../../interfaces/profile";
import { FetchUserProfileAction } from '../actions/profile.action';
import { ActionType } from '../action_types';

export const updateBorrowerProfile = (profile: Borrower) => {
  return {
    type: ActionType.UPDATE_BORROWER_PROFILE,
    payload: { profile },
  };
};

export const fetchUserProfile = () => async (dispatch: Dispatch<FetchUserProfileAction>) => {
  try {
    dispatch({
      type: ActionType.FETCHING,
      payload: {
        fetching: true,
      },
    });
    const response = await getUserProfileApi();
    const data: UserProfile = response.data;

    dispatch({
      type: ActionType.FETCH_USER_PROFILE,
      payload: {
        userProfile: data,
        fetching: false
      },
    });
  } catch (error) {
    dispatch({
      type: ActionType.SET_ERROR,
      payload: {
        error: handleApiError(error),
        fetching: false,
      },
    });
  }
};
